var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.hasImage
      ? _c(
          "div",
          { staticClass: "highlight-image" },
          [
            _c("AImage", {
              attrs: {
                img: _vm.getImage,
                preset: _vm.getPreset,
                ratio: _vm.getRatio,
                responsive: "",
                contain: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "highlight-content" }, [
      _vm.getHighlightLeadline
        ? _c("div", { staticClass: "highlight-leadline" }, [
            _c("h4", [_vm._v(_vm._s(_vm.getHighlightLeadline))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.getHighlightDescription
        ? _c("div", {
            staticClass: "highlight-description",
            domProps: { innerHTML: _vm._s(_vm.getHighlightDescription) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getHighlightTitle
        ? _c("div", { staticClass: "highlight-name" }, [
            _vm._v("\n      " + _vm._s(_vm.getHighlightTitle) + "\n    "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }